import BeasleyLogo from './BeasleyLogo';
import CashByCreativeLogo from './CashByCreativeLogo';
import CCCLogo from './CCCLogo';
import CreativeLoveLogo from './CreativeLoveLogo';
import SpecByteLogo from './SpecByteLogo';
import AudacyFlashLogo from './AudacyFlashLogo';
import YamanairLogo from './YamanairLogo';

function getLogo(theme) {
  switch (theme) {
    case 'SPECbyte':
      return <SpecByteLogo width="320px" sx={{ display: { md: 'inline', xs: 'none' }, }} />;
    case 'CCC':
      return <CCCLogo width="320px" sx={{ display: { md: 'inline', xs: 'none' }, }} variant="dark" />;
    case 'CashByCreative':
      return <CashByCreativeLogo width="300px" sx={{ display: { md: 'inline', xs: 'none' }, }} />;
    case 'CreativeLove':
      return <CreativeLoveLogo width="240px" sx={{ display: { md: 'inline', xs: 'none' }, }} />;
    case 'AudacyFlash':
      return <AudacyFlashLogo width="180px" sx={{ display: { md: 'inline', xs: 'none' }, }} />;
    case 'Beasley':
      return <BeasleyLogo width="180px" sx={{ display: { md: 'inline', xs: 'none' }, }} />;
    case 'Admin':
      return <YamanairLogo width="180px" sx={{ display: { md: 'inline', xs: 'none' }, }} />;
    default:
      return null
  }
}

export {
  BeasleyLogo,
  CashByCreativeLogo,
  CCCLogo,
  CreativeLoveLogo,
  SpecByteLogo,
  AudacyFlashLogo,
  YamanairLogo,
  getLogo
};